import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { getColorClassName, RichText } from '@wordpress/block-editor';
export default function save(_ref) {
  var _classnames;

  var attributes = _ref.attributes;
  var align = attributes.align,
      content = attributes.content,
      customTextColor = attributes.customTextColor,
      level = attributes.level,
      textColor = attributes.textColor;
  var tagName = 'h' + level;
  var textClass = getColorClassName('color', textColor);
  var className = classnames((_classnames = {}, _defineProperty(_classnames, textClass, textClass), _defineProperty(_classnames, "has-text-align-".concat(align), align), _classnames));
  return createElement(RichText.Content, {
    className: className ? className : undefined,
    tagName: tagName,
    style: {
      color: textClass ? undefined : customTextColor
    },
    value: content
  });
}
//# sourceMappingURL=save.js.map